import { z } from 'zod';
import { ORGANIZATION_TYPES } from '@/auth/types';

/** 画面のフォーム検証（API 側の zod と同じ制約をフロントでも先に確認する） */
const base = z.object({
  loginId: z
    .string()
    .trim()
    .min(3, '3文字以上で入力してください')
    .max(64, '64文字以内で入力してください')
    .regex(/^[A-Za-z0-9._@-]+$/, '半角英数字と . _ @ - のみ使用できます'),
  name: z.string().trim().min(1, '氏名を入力してください').max(100, '100文字以内で入力してください'),
  organizationType: z.enum(ORGANIZATION_TYPES, { errorMap: () => ({ message: '組織区分を選択してください' }) }),
  businessOperatorId: z.number().int().positive('正の整数で入力してください').nullable(),
  isActive: z.boolean(),
  /** 2段階認証：必須（true）／任意（false） */
  mfaRequired: z.boolean(),
  password: z.string(),
  passwordConfirm: z.string(),
});

function refine(isNew: boolean) {
  return base.superRefine((v, ctx) => {
    if (v.organizationType === '漁協' && v.businessOperatorId == null) {
      ctx.addIssue({ code: 'custom', path: ['businessOperatorId'], message: '漁協ユーザーは事業実施者の指定が必須です' });
    }
    if (isNew || v.password) {
      if (v.password.length < 8) ctx.addIssue({ code: 'custom', path: ['password'], message: '8文字以上で入力してください' });
      if (v.password.length > 128) ctx.addIssue({ code: 'custom', path: ['password'], message: '128文字以内で入力してください' });
      if (v.password !== v.passwordConfirm)
        ctx.addIssue({ code: 'custom', path: ['passwordConfirm'], message: 'パスワードが一致しません' });
    }
  });
}

export const createUserSchema = refine(true);
export const editUserSchema = refine(false);
export type UserFormValues = z.infer<typeof base>;

export const emptyUserForm: UserFormValues = {
  loginId: '',
  name: '',
  organizationType: '漁協',
  businessOperatorId: null,
  isActive: true,
  mfaRequired: false,
  password: '',
  passwordConfirm: '',
};
